import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonLoading, IonPage, IonRefresher, IonRefresherContent, IonSlide, IonSlides, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { helpCircle, list } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { listaAgendamento, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './Agendamentos.css';

const Agendamentos: React.FC = () => {

  const history = useHistory();
  const [aba, setAba] = useState("proximos");
  const [arrayAgendamentos, setArrayAgendamentos] = useState<any>([]);
  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [agendamentopk, setAgendamentopk] = useState("");
  const [showLoading, setShowLoading] = useState(true);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    loadItens();
    setEsconderMenu(false);
  });

  let slides = useRef(document.createElement('ion-slides'));

  const nextSlide = () => {
    slides.current.getActiveIndex().then(
      isEnd => {
        if (isEnd === 1)
          setAba("anteriores")
        else
          setAba("proximos")
      }
    );
  }

  function pisca(valor: string) {
    if (valor === "Agendado") return "pisca piscaverde";
    else return "pisca";
  }

  function carregarDetalhes(agendamentoid: any) {
    setChamadaRealizada(false);
    history.push("agendamentos/agendamentosdetalhes", { agendamentoid: agendamentoid });
  }


  const loadItens = () => {

    if (!chamadaRealizada) {
      setChamadaRealizada(true);
      carregarAgendamentos();
    }

    if (arrayAgendamentos === undefined || arrayAgendamentos.length === 0) {
      return (
        <IonCard key="primeira">
          <IonCardHeader >
            <IonCardTitle>Aqui aparecem os agendamentos de entregas e serviços</IonCardTitle>
            <IonCardSubtitle></IonCardSubtitle>
            <IonLabel></IonLabel>
          </IonCardHeader>
          <IonCardContent>
          </IonCardContent>
        </IonCard>
      );
    }

    return arrayAgendamentos.map((value: any, index: any, arr: any) =>
      (index === 0 || (arr[index - 1] && new Date(value.dataAgendamento).toLocaleString('pt-BR').substring(0, 10) !== new Date(arr[index - 1].dataAgendamento).toLocaleString('pt-BR').substring(0, 10))) ?
        (<>
          <IonCard className={"card"} key={value.dataAgendamento + index.toString()}>
            <IonCardHeader key={value.dataAgendamento}>
              <IonCardTitle>
                <div className={"cabecalho"} >{new Date(value.dataAgendamento).toLocaleString('pt-BR').substring(0, 10) === new Date().toLocaleString('pt-BR').substring(0, 10) ? "Hoje" : new Date(value.dataAgendamento).toLocaleString('pt-BR').substring(0, 10)}</div>
              </IonCardTitle>
            </IonCardHeader>
          </IonCard>
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>{value.descricaoAgendamento}</IonCardTitle>
              <IonCardSubtitle hidden={!value.nomeProjeto}>
                <IonBadge color="primary" >{value.nomeProjeto}</IonBadge>
              </IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <div>
                <IonLabel>Empresa: {value.empresaNome || "não identificada"}
                  <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (value.empresaTelefone)}>
                    <IonIcon slot="icon-only" icon={helpCircle} />
                  </a>
                </IonLabel>
              </div>
              <div>
                <IonLabel>Prestador: {value.prestadorNome || "não identificada"}</IonLabel>
              </div>
              <div hidden={value.parametroMostrarHorario}>
                <IonLabel>Período: {value.periodoAgendamento || "não identificada"}</IonLabel>
              </div>
              <div hidden={!value.parametroMostrarHorario}>
                <IonLabel>Horário: {value.horaAgendamento || "não identificada"}</IonLabel>
              </div>
              <IonButton fill='clear' slot="end" onClick={() => { carregarDetalhes(value.pk); }}>Ver Detalhes</IonButton>

              <div className="status">
                <IonLabel>{value.status}</IonLabel>
                <div className={pisca(value.status)}></div>
              </div>
            </IonCardContent>
          </IonCard>
        </>
        ) :
        (
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>{value.descricaoAgendamento}</IonCardTitle>
              <IonCardSubtitle hidden={!value.nomeProjeto}>
                <IonBadge color="primary" >{value.nomeProjeto}</IonBadge>
              </IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <div>
                <IonLabel>Empresa: {value.empresaNome || "não identificada"}
                  <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (value.empresaTelefone)}>
                    <IonIcon slot="icon-only" icon={helpCircle} />
                  </a>
                </IonLabel>
              </div>
              <div>
                <IonLabel>Prestador: {value.prestadorNome || "não identificada"}</IonLabel>
              </div>
              <div hidden={value.parametroMostrarHorario}>
                <IonLabel>Período: {value.periodoAgendamento || "não identificada"}</IonLabel>
              </div>
              <div hidden={!value.parametroMostrarHorario}>
                <IonLabel>Horário: {value.horaAgendamento || "não identificada"}</IonLabel>
              </div>
              <IonButton fill='clear' slot="end" onClick={() => { carregarDetalhes(value.pk); }}>Ver Detalhes</IonButton>

              <div className="status">
                <IonLabel>{value.status}</IonLabel>
                <div className={pisca(value.status)}></div>
              </div>
            </IonCardContent>
          </IonCard>
        )
    );

  }



  function carregarAgendamentos() {
    const consultar = async () => {

      requestService(listaAgendamento.url, {
        method: listaAgendamento.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          setArrayAgendamentos(response.Items);
          if (response.LastEvaluatedKey) {
            setAgendamentopk(response.LastEvaluatedKey.pk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setAgendamentopk("");
            setDesabilitarInfiniteScroll(true);
          }
          setShowLoading(false);
        },
        (error: any) => {
          setShowLoading(false);
        });
    }

    consultar();
  }

  async function carregarMaisAgendamentos($event: CustomEvent<void>) {

    await carregarMaisAgendamentosChamada().then(() => {
      console.log("terminou resultados");
    });
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisAgendamentosChamada() {

    requestService(listaAgendamento.url + "?pk=" + agendamentopk, {
      method: listaAgendamento.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(arrayAgendamentos.length);
        for (let i = 0; i < response.Items.length; i++) {
          console.log("resultados");
          arrayAgendamentos.push(response.Items[i]);
        }
        console.log(arrayAgendamentos.length);
        if (response.LastEvaluatedKey) {
          setAgendamentopk(response.LastEvaluatedKey.pk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setAgendamentopk("");
          setDesabilitarInfiniteScroll(true);
          console.log("finalizou");
        }
      },
      (error: any) => {
        console.log(error);
        if (error.status === 426) { // atualizar versao
          history.replace("/atualizar");
        }
        else if (error !== 408) {
          history.replace("/primeiroacesso/");
        }
      });
  }

  function tempoCorrido(horario: Date, horarioFim: Date) {
    var g = Math.ceil((horarioFim.getTime() - horario.getTime()) / 1000 / 60);
    return Math.floor(g / 60).toString() + 'h' + ('0' + (g % 60).toString()).substr(-2) + 'min';
  }

  function doRefresh(event: any) {
    carregarAgendamentos();
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton>
              <IonIcon slot="icon-only" icon={list} />
            </IonButton>
          </IonButtons>
          <IonTitle>Agenda</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={"Agendamentos"}>

        <IonSlides className={"AgendamentosSlides"} ref={slides} onIonSlideWillChange={nextSlide}>
          <IonSlide key="slide1">
            {loadItens()}
          </IonSlide>
        </IonSlides>


        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisAgendamentos(e)}
          position="bottom"
          disabled={desabilitarInfiniteScroll}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais operações..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>
    </IonPage>
  );
};

export default Agendamentos;
